import Chart from "react-apexcharts";

// ----------------------------------------------------------------------

export { default as StyledChart } from "./ChartArea/styles";

export { default as useChart } from "../hooks/useChart";

export default Chart;
